import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { AppCheckbox } from "../../../../shared/components/AppCheckbox";
import { AppInput } from "../../../../shared/components/AppInput";
import styles from "./styles.module.css";

interface Props {
  uri: string;
  title: string;
  tokenOn: boolean;
  handleSetForm: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: "uri" | "title" | "token",
  ) => void;
}

export const CreateExtraAppForm = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <AppInput
        value={props.uri}
        placeholder={t("extra_app.uri_placeholder")}
        onChange={(event) => props.handleSetForm(event, "uri")}
      />
      <AppInput
        value={props.title}
        placeholder={t("extra_app.title_placeholder")}
        onChange={(event) => props.handleSetForm(event, "title")}
      />
      <AppCheckbox
        checked={props.tokenOn}
        onChange={(event) => props.handleSetForm(event, "token")}
      >
        {t("extra_app.checkbox_label")}
      </AppCheckbox>
    </div>
  );
};
